const isImageByUrl = (url) => {
  if (!url) return false;

  const imageExtensions = ["jpg", "jpeg", "png", "gif"];
  const extension = url.split(".").pop().toLowerCase();

  if (imageExtensions.includes(extension)) {
    return true;
  } else {
    return false;
  }
};

export default isImageByUrl;
